import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import CookieConsent from './cookieconsent'
import Cookies from 'js-cookie';



  

  const Login = () => {
    const [Username, setUser] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();

    
const handleCookieAccept = () => {
  Cookies.set('cookieConsent', 'true', { expires: 365 });
};

const hasCookieConsent = Cookies.get('cookieConsent') === 'true';

    const submithandler = (e) => {
      e.preventDefault()
      axios.post("https://api.kgphotographies.com/api/login",{
        Username,
        password
      },{withCredentials: true})
      .then((res)=>{
        console.log(res.data.user);
        navigate(`/Addphoto`)
      }).catch((err)=>{
        console.log(err.response.data)
      });
    };


return(
    <div className='backgroundimg'>
    
    <form onSubmit={submithandler} autoComplete="off">
        <div>
            <h1 className=''>Login</h1>
        </div>
        <div className="form-label">
                <label className=''><h3>Username:</h3> 
                <input className="form-control border border-dark"
                onChange={(e) =>setUser(e.target.value)}
                name="Username"
                type="text"
                />
                </label>
            </div>

          <div className="form-label">
              <label className='form-label'>
                <h3>Password:</h3>
                <input
                  className="form-control border border-dark"
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  type="password"  // Change type to "password"
                  autoComplete="current-password"  // Add autocomplete attribute
                />
              </label>
            </div>
                  {/* Cookie consent pop-up */}
            <div>

              <CookieConsent onAccept={handleCookieAccept} />
            </div>
              {hasCookieConsent ? null : <CookieConsent onAccept={handleCookieAccept} />}
            <button className='btn custom-btn mt-3 p2'>Login</button>
        
        </form>
        
        </div>


    );
};


export default Login